
import "../style.css";
import CourseImg from "../../assets/img/courseImg1.png";
import ServiceImg from "../../assets/img/servicepg.png";

export default function PageWiseLearnMore(props) {
  const data = props.learnMoreData.topHeaderSection;
  return (
    <div className="page-wise-learn-more">
      {(props.activePageId === "1" || props.activePageId === "free") ? (
        <div className="language-prep">
          <div className="learn-more-page-wise">

            <section className="pt-6 pb-2 px-6 text-left md:hidden top-header-section">
              <h2 className="font-playfair text-[28px] font-semibold text-[#101828] leading-tight mb-2">
                {data.header}
              </h2>
              <p className="font-lato text-[18px] text-[#574d49] leading-relaxed">
                {data.desc}
              </p>

              <img
                className="w-full mt-4 rounded-lg"
                src={data.img}
                alt="Students"
              />
            </section>

            {/* DESKTOP HERO + TEXT */}
            <div className="hidden md:block">
              <div className="services-rectangle page-wise-padding">
                <div className="frame">
                  <div className="service-div-2">
                    <div className="font-playfair text-4xl font-semibold text-[#101828] mb-2">
                      {data.header}
                    </div>
                  </div>
                  <p className="font-lato text-xl text-[#574d49] leading-relaxed">
                    {data.desc}
                  </p>
                </div>
                <img
                  className="services-rectangle-2"
                  alt="Rectangle"
                  src={data.img}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="services">
          <section className=" pt-2 pb-0 text-center md:hidden">
            <h2 className="text-[28px] font-semibold text-[#051d62] leading-tight">
              {data.header}
            </h2>

            <p className="p-2 mt-4 text-gray-600 text-[16px] leading-relaxed">
              {data.desc}
            </p>

            <img
              className="w-full mt-4 rounded-lg"
              src={data.img}
              alt="Students"
            />
          </section>

          {/* DESKTOP HERO + TEXT */}
          <div className="hidden md:block">
            <div className="services-rectangle">
              <div className="frame">
                <div className="service-div-2">
                  <div className="service-text-wrapper-2">
                    {data.header}
                  </div>


                </div>

                <p className="p">
                  {data.desc}
                </p>
              </div>

              <img
                className="services-rectangle-2"
                alt="Rectangle"
                src={data.img}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
